import { isBrowser } from './base';
import { setTheme, toggleTheme, type ThemeMode } from './theme';

interface Controllable extends HTMLElement {
  show?: () => void;
  hide?: () => void;
  toggle?: () => void;
}

const CONTROLLABLE = 'hn-dialog, hn-drawer, hn-sidebar, hn-dropdown, hn-tooltip';

/**
 * Déclencheurs déclaratifs, sans écrire de JavaScript (HTML statique, PHP, AngularJS…) :
 *   <button data-hn-open="ma-modale">      ouvre l'élément #ma-modale
 *   <button data-hn-close="ma-modale">     le ferme (sans valeur : l'élément parent le plus proche)
 *   <button data-hn-toggle="menu">         bascule (#menu peut être un <hn-sidebar>)
 *   <button data-hn-set-theme="dark|light|auto|toggle">
 */
function onClick(event: MouseEvent): void {
  const source = (event.target as Element | null)?.closest?.('[data-hn-open], [data-hn-close], [data-hn-toggle], [data-hn-set-theme]');
  if (!source || (source as HTMLButtonElement).disabled) return;

  const theme = source.getAttribute('data-hn-set-theme');
  if (theme !== null) {
    const rect = source.getBoundingClientRect();
    const origin = { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
    if (theme === 'toggle' || theme === '') toggleTheme({ origin });
    else setTheme(theme as ThemeMode, { origin });
    return;
  }

  const find = (id: string | null): Controllable | null =>
    id ? (document.getElementById(id) as Controllable | null) : (source.closest(CONTROLLABLE) as Controllable | null);

  if (source.hasAttribute('data-hn-open')) find(source.getAttribute('data-hn-open'))?.show?.();
  else if (source.hasAttribute('data-hn-close')) find(source.getAttribute('data-hn-close') || null)?.hide?.();
  else if (source.hasAttribute('data-hn-toggle')) find(source.getAttribute('data-hn-toggle'))?.toggle?.();
}

let installed = false;

/** Active les déclencheurs data-hn-* (appelé automatiquement à l'import). */
export function installCommands(): void {
  if (!isBrowser || installed) return;
  installed = true;
  document.addEventListener('click', onClick);
}
